"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEventInfoText = exports.getAndTranslateEventClassText = exports.getAndTranslateEventText = exports.EVENT_TRANSLATION_DICTIONARY = exports.getValue = void 0;
function getValue(obj, key) {
    var keys = key.split(/\./g).reverse();
    var val = obj, cur;
    while (cur = keys.pop()) {
        if (!val || !val.hasOwnProperty((cur))) {
            return '';
        }
        val = val[cur];
    }
    return val;
}
exports.getValue = getValue;
// a dictionary to find the translation string for specific event class->type with its parameters
exports.EVENT_TRANSLATION_DICTIONARY = {
    analoginputevent: {
        getText: function (e) {
            var params = {
                input: getValue(e.details, 'input.name'),
                value: getValue(e.details, 'values.value'),
                limit: getValue(e.details, 'values.limit'),
                assettype: getValue(e.details, 'assetType.name'),
                asset: getValue(e.details, 'asset.name'),
                driver: getValue(e.details, 'driver.name'),
                address: getValue(e.details, 'telemetry.location.address'),
            };
            switch (e.type) {
                case 'low':
                    return { translationString: 'ANALOG_INPUT.LOW', params: params };
                case 'high':
                    return { translationString: 'ANALOG_INPUT.HIGH', params: params };
                case 'inrange':
                    return { translationString: 'ANALOG_INPUT.INRANGE', params: params };
                case 'drop':
                    return { translationString: 'ANALOG_INPUT.DROP', params: params };
                case 'jump':
                    return { translationString: 'ANALOG_INPUT.JUMP', params: params };
            }
        }
    },
    assetactivationevent: {
        getText: function (e) {
            var params = {
                assettype: getValue(e.details.assetType, 'name'),
                asset: getValue(e.details.asset, 'name'),
                address: getValue(e.details.telemetry, 'location.address'),
            };
            if (e.details.driver) {
                return {
                    translationString: (e.type === 'activate' ? 'ASSET_ACTIVATION.ACTIVATE_DRIVER' : 'ASSET_ACTIVATION.DEACTIVATE_DRIVER'),
                    params: __assign(__assign({}, params), { driver: e.details.driver.name }),
                };
            }
            else {
                return {
                    translationString: (e.type === 'activate' ? 'ASSET_ACTIVATION.ACTIVATE' : 'ASSET_ACTIVATION.DEACTIVATE'),
                    params: params,
                };
            }
        }
    },
    assetstatechangeevent: {
        getText: function (e) {
            var params = {
                profile: getValue(e.details.profile, 'name'),
                state: getValue(e.details.state, 'state'),
                assettype: getValue(e.details.assetType, 'name'),
                asset: getValue(e.details.asset, 'name'),
                address: getValue(e.details.telemetry, 'location.address'),
            };
            if (e.details.driver) {
                return {
                    translationString: 'ASSET_STATE_CHANGE.DRIVER',
                    params: __assign(__assign({}, params), { driver: e.details.driver.name }),
                };
            }
            else {
                return { translationString: 'ASSET_STATE_CHANGE.NO_DRIVER', params: params };
            }
        },
        getClassText: function (e) {
            var _a, _b;
            if ((_a = e === null || e === void 0 ? void 0 : e.details) === null || _a === void 0 ? void 0 : _a.state) {
                return { value: (_b = e === null || e === void 0 ? void 0 : e.details) === null || _b === void 0 ? void 0 : _b.state };
            }
            else {
                return { translationString: 'EVENTS.NAMES.' + e.class.toUpperCase() };
            }
        },
    },
    camerainputevent: {
        getText: function (e) { return ({
            translationString: (e.type === 'photo') ? 'CAMERA_INPUT.PHOTO' : 'CAMERA_INPUT.VIDEO',
            params: {
                assettype: getValue(e.details, 'assetType.name'),
                asset: getValue(e.details, 'asset.name'),
                address: getValue(e.details.telemetry, 'location.address'),
            },
        }); },
        getClassText: function (e) {
            return { translationString: 'EVENTS.NAMES.CAMERAINPUTEVENT_' + e.type.toUpperCase() };
        }
    },
    devicetextevent: {
        getText: function (e) {
            if (e.details.asset && e.details.asset.name) {
                return {
                    translationString: 'DEVICE_TEXT.ASSET',
                    params: {
                        asset: getValue(e.details, 'asset.name'),
                        message: getValue(e.details, 'message'),
                    },
                };
            }
            else {
                return {
                    translationString: 'DEVICE_TEXT.DEVICE',
                    params: {
                        device: getValue(e.details, 'device.name'),
                        message: getValue(e.details, 'message'),
                    },
                };
            }
        },
    },
    digitalinputevent: {
        getText: function (e) {
            var params = {
                input: getValue(e.details, 'input.name'),
                assettype: getValue(e.details, 'assetType.name'),
                asset: getValue(e.details, 'asset.name'),
                address: getValue(e.details, 'telemetry.location.address'),
            };
            if (e.details.driver) {
                return {
                    translationString: (e.type === 'activate') ? 'DIGITAL_INPUT.DRIVER_ACTIVATE' : 'DIGITAL_INPUT.DRIVER_DEACTIVATE',
                    params: __assign(__assign({}, params), { driver: e.details.driver.name }),
                };
            }
            else {
                return {
                    translationString: (e.type === 'activate') ? 'DIGITAL_INPUT.ACTIVATE' : 'DIGITAL_INPUT.DEACTIVATE',
                    params: params,
                };
            }
        },
        getClassText: function (e) {
            var _a;
            if ((_a = e === null || e === void 0 ? void 0 : e.details) === null || _a === void 0 ? void 0 : _a.input) {
                return { value: "".concat(e.details.input.name, " ").concat(e.details.input.text) };
            }
            else {
                return { translationString: 'EVENTS.NAMES.' + e.class.toUpperCase() };
            }
        },
    },
    digitaloutputevent: {
        getText: function (e) { return ({
            translationString: (e.type === 'activate') ? 'DIGITAL_OUTPUT.ACTIVATE' : 'DIGITAL_OUTPUT.DEACTIVATE',
            params: {
                output: getValue(e.details, 'output.name'),
                assettype: getValue(e.details, 'assetType.name'),
                asset: getValue(e.details, 'asset.name'),
                address: getValue(e.details, 'telemetry.location.address'),
            },
        }); },
        getClassText: function (e) {
            var _a;
            if ((_a = e === null || e === void 0 ? void 0 : e.details) === null || _a === void 0 ? void 0 : _a.output) {
                return { value: "".concat(e.details.output.name, " ").concat(e.details.output.text) };
            }
            else {
                return { translationString: 'EVENTS.NAMES.' + e.class.toUpperCase() };
            }
        },
    },
    valueinputevent: {
        getText: function (e) { return ({
            translationString: (e.type === 'activate') ? 'VALUE_INPUT.ACTIVATE' : 'VALUE_INPUT.DEACTIVATE',
            params: {
                input: getValue(e.details, 'input.name'),
                text: getValue(e.details, 'input.text'),
                assettype: getValue(e.details, 'assetType.name'),
                asset: getValue(e.details, 'asset.name'),
                address: getValue(e.details, 'telemetry.location.address'),
            },
        }); },
        getClassText: function (e) {
            var _a;
            if ((_a = e === null || e === void 0 ? void 0 : e.details) === null || _a === void 0 ? void 0 : _a.input) {
                return { value: "".concat(e.details.input.name, " ").concat(e.details.input.text) };
            }
            else {
                return { translationString: 'EVENTS.NAMES.' + e.class.toUpperCase() };
            }
        },
    },
    geoborderevent: {
        getText: function (e) {
            var params = {
                origin: getValue(e.details, 'origin.name'),
                destination: getValue(e.details, 'destination.name'),
                assettype: getValue(e.details, 'assetType.name'),
                asset: getValue(e.details, 'asset.name'),
                address: getValue(e.details, 'telemetry.location.address'),
            };
            if (e.details.driver) {
                return {
                    translationString: 'GEO_BORDER.DRIVER',
                    params: __assign(__assign({}, params), { driver: e.details.driver.name }),
                };
            }
            else {
                return { translationString: 'GEO_BORDER.NO_DRIVER', params: params };
            }
        },
    },
    geolockevent: {
        getText: function (e) {
            var params = {
                user: getValue(e.details, 'geoLock.userName') || getValue(e.details, 'source'),
                assettype: getValue(e.details, 'assetType.name'),
                asset: getValue(e.details, 'asset.name'),
            };
            if (e.details.driver) {
                return {
                    translationString: 'GEO_LOCK.DRIVER',
                    params: __assign(__assign({}, params), { driver: e.details.driver.name }),
                };
            }
            else {
                return { translationString: 'GEO_LOCK.NO_DRIVER', params: params };
            }
        },
    },
    privacyevent: {
        getText: function (e) {
            var params = {
                assettype: getValue(e.details.assetType, 'name'),
                asset: getValue(e.details.asset, 'name'),
                address: getValue(e.details.telemetry, 'location.address'),
            };
            return {
                translationString: (e.type === 'activate' ? 'PRIVACY.ACTIVATE' : 'PRIVACY.DEACTIVATE'),
                params: params,
            };
        },
    },
    excessiveidleevent: {
        getText: function (e) {
            var params = {
                limit: getValue(e.details, 'limit.value'),
                assettype: getValue(e.details, 'assetType.name'),
                asset: getValue(e.details, 'asset.name'),
                address: getValue(e.details, 'telemetry.location.address'),
            };
            if (e.details.driver) {
                return {
                    translationString: 'IDLE.DRIVER',
                    params: __assign(__assign({}, params), { driver: e.details.driver.name }),
                };
            }
            else {
                return { translationString: 'IDLE.NO_DRIVER', params: params };
            }
        },
    },
    fuelingevent: {
        getText: function (e) {
            var params = {
                assettype: getValue(e.details, 'assetType.name'),
                asset: getValue(e.details, 'asset.name'),
                volume: getValue(e.details, 'volume'),
                volumeUnit: getValue(e.details, 'volumeUnit'),
                cost: getValue(e.details, 'cost'),
                currency: getValue(e.details, 'currency'),
                address: getValue(e.details, 'telemetry.location.address'),
            };
            return {
                translationString: 'FUELING',
                params: params,
            };
        },
        getInfo: function (e, i18n, _units) {
            var result = [];
            var fuelSite = e.details.fuelSite;
            var key = 'SHARED.FEED_ENTRY.EVENT.FUELING.VALUES.';
            if (fuelSite) {
                if (fuelSite.name) {
                    result.push({ title: i18n.instant(key + 'TITLE.SITE'), value: fuelSite.name });
                }
                if (fuelSite.address) {
                    result.push({ title: i18n.instant(key + 'TITLE.ADDRESS'), value: fuelSite.address });
                }
            }
            if (e.details.volume) {
                result.push({ title: i18n.instant(key + 'TITLE.VOLUME'), value: "".concat(e.details.volume).concat(e.details.volumeUnit || '') });
            }
            if (e.details.cost) {
                result.push({ title: i18n.instant(key + 'TITLE.COST'), value: "".concat(e.details.cost, " ").concat(e.details.currency || '') });
            }
            return result;
        }
    },
    objectevent: {
        getText: function (e) {
            var params = {
                user: '<b>' + getValue(e.details, 'user.name') + '</b>',
                type: getValue(e.details, 'object.type'),
                name: '<b>' + getValue(e.details, 'object.name') + '</b>',
            };
            switch (e.type) {
                case 'created':
                    return { translationString: 'OBJECT.CREATED', params: params };
                case 'deleted':
                    return { translationString: 'OBJECT.DELETED', params: params };
                case 'modified':
                    return { translationString: 'OBJECT.MODIFIED', params: params };
            }
        },
    },
    overspeedevent: {
        getText: function (e, units) {
            var params = {
                limit: getValue(e.details, 'limit.value'),
                assettype: getValue(e.details, 'assetType.name'),
                asset: getValue(e.details, 'asset.name'),
                address: getValue(e.details, 'telemetry.location.address'),
            };
            switch (e.type) {
                case 'start':
                    if (e.details.driver) {
                        return {
                            translationString: 'OVERSPEED.DRIVER',
                            params: __assign(__assign({}, params), { driver: e.details.driver.name }),
                        };
                    }
                    return { translationString: 'OVERSPEED.NO_DRIVER', params: params };
                case 'band_end':
                    var distance = units.format(e.details.values.distance, 'distance');
                    params = __assign(__assign({}, params), { duration: getValue(e.details, 'values.duration'), distance: distance, band: getValue(e.details, 'band.name'), maxSpeed: getValue(e.details, 'text.maxSpeed') });
                    if (e.details.driver) {
                        return {
                            translationString: 'OVERSPEED.PROFILE_DRIVER',
                            params: __assign(__assign({}, params), { driver: e.details.driver.name }),
                        };
                    }
                    return { translationString: 'OVERSPEED.PROFILE_NO_DRIVER', params: params };
                default:
                    return { translationString: 'OVERSPEED.UNKNOWN_EVENT_TYPE', params: params };
            }
        },
    },
    reminderevent: {
        getText: function (e, units) {
            var params = {
                assettype: getValue(e.details, 'assetType.name'),
                asset: getValue(e.details, 'asset.name'),
                name: getValue(e.details, 'reminder.name'),
            };
            switch (e.type) {
                case 'odo':
                    return {
                        translationString: 'REMINDER.ODO',
                        params: __assign(__assign({}, params), { value: units.format(e.details.reminder.value, 'distance') }),
                    };
                case 'hours':
                    return {
                        translationString: 'REMINDER.HOURS',
                        params: __assign(__assign({}, params), { value: e.details.reminder.value }),
                    };
                default:
                    return { translationString: 'REMINDER.DEFAULT', params: params };
            }
        },
    },
    reportcompletionevent: {
        getText: function (e) {
            var params = {
                report: getValue(e.details, 'report.name'),
                user: getValue(e.details, 'user.name'),
            };
            if (e.type === 'success') {
                return {
                    translationString: 'REPORT_COMPLETION.SUCCESS',
                    params: params,
                };
            }
            else {
                return {
                    translationString: 'REPORT_COMPLETION.FAILURE',
                    params: __assign(__assign({}, params), { error: getValue(e.details, 'error.text') }),
                };
            }
        },
    },
    smsevent: {
        getText: function (e) { return ({
            translationString: (e.type === 'success') ? 'SMS.SUCCESS' : 'SMS.FAILURE',
            params: {
                user: getValue(e.details, 'user.name'),
                asset: getValue(e.details, 'asset.name'),
            },
        }); },
    },
    tagevent: {
        getText: function (e) {
            var params = {
                tag: getValue(e.details, 'tag.name'),
            };
            if (e.details.tagAsset) {
                params['tagassettype'] = getValue(e.details, 'tagAssetType.name');
                params['tagasset'] = getValue(e.details, 'tagAsset.name');
                switch (e.type) {
                    case 'heartbeat':
                        return { translationString: 'TAG.ASSET_HEARTBEAT', params: params };
                    case 'gained':
                        return {
                            translationString: 'TAG.ASSET_GAINED',
                            params: __assign(__assign({}, params), { address: getValue(e.details, 'telemetry.location.address'), asset: getValue(e.details, 'asset.name') }),
                        };
                    case 'lost':
                        return {
                            translationString: 'TAG.ASSET_LOST',
                            params: __assign(__assign({}, params), { address: getValue(e.details, 'telemetry.location.address'), asset: getValue(e.details, 'asset.name') }),
                        };
                    case 'alarm':
                        return {
                            translationString: 'TAG.ASSET_ALARM',
                            params: __assign(__assign({}, params), { address: getValue(e.details, 'telemetry.location.address'), asset: getValue(e.details, 'asset.name'), tag: getValue(e.details, 'tag.text') }),
                        };
                    default:
                        return { translationString: 'TAG.ASSET_DEFAULT', params: params };
                }
            }
            else {
                switch (e.type) {
                    case 'heartbeat':
                        return { translationString: 'TAG.NO_ASSET_HEARTBEAT', params: params };
                    case 'gained':
                        return {
                            translationString: 'TAG.NO_ASSET_GAINED',
                            params: __assign(__assign({}, params), { address: getValue(e.details, 'telemetry.location.address'), asset: getValue(e.details, 'asset.name') }),
                        };
                    case 'lost':
                        return {
                            translationString: 'TAG.NO_ASSET_LOST',
                            params: __assign(__assign({}, params), { address: getValue(e.details, 'telemetry.location.address'), asset: getValue(e.details, 'asset.name') }),
                        };
                    case 'alarm':
                        return {
                            translationString: 'TAG.NO_ASSET_ALARM',
                            params: __assign(__assign({}, params), { address: getValue(e.details, 'telemetry.location.address'), asset: getValue(e.details, 'asset.name'), tag: getValue(e.details, 'tag.text'), text: getValue(e.details, 'tag.text') }),
                        };
                    default:
                        return { translationString: 'TAG.NO_ASSET_DEFAULT', params: params };
                }
            }
        },
    },
    devicepollevent: {
        getText: function (e) {
            var params = {
                user: getValue(e.details, 'user.name'),
                asset: getValue(e.details, 'asset.name'),
            };
            if (e.type === 'success') {
                return { translationString: 'DEVICE_POLL.SUCCESS', params: params };
            }
            else {
                return {
                    translationString: 'DEVICE_POLL.FAILURE',
                    params: __assign(__assign({}, params), { error: getValue(e.details, 'error.message') }),
                };
            }
        },
    },
    deviceoutputevent: {
        getText: function (e) {
            var params = {
                user: getValue(e.details, 'user.name'),
                output: getValue(e.details, 'output.name'),
                assettype: getValue(e.details, 'assetType.name'),
                asset: getValue(e.details, 'asset.name'),
            };
            if (e.type === 'failure') {
                return {
                    translationString: 'DEVICE_OUTPUT.FAILURE',
                    params: __assign(__assign({}, params), { value: getValue(e.details, 'output.value'), error: getValue(e.details, 'error.message') }),
                };
            }
            else {
                if (e.details.output && e.details.output.value > 0) {
                    return {
                        translationString: 'DEVICE_OUTPUT.PULSE',
                        params: __assign(__assign({}, params), { pulse: getValue(e.details, 'output.pulse') }),
                    };
                }
                else {
                    return {
                        translationString: 'DEVICE_OUTPUT.VALUE',
                        params: __assign(__assign({}, params), { value: getValue(e.details, 'output.value') }),
                    };
                }
            }
        },
    },
    deviceuploadevent: {
        getText: function (e) {
            var params = {
                user: getValue(e.details, 'user.name'),
                assettype: getValue(e.details, 'assetType.name'),
                asset: getValue(e.details, 'asset.name'),
            };
            if (e.type === 'success') {
                return { translationString: 'DEVICE_UPLOAD.SUCCESS', params: params };
            }
            else {
                return {
                    translationString: 'DEVICE_UPLOAD.FAILURE',
                    params: __assign(__assign({}, params), { error: getValue(e.details, 'error.message') }),
                };
            }
        },
    },
    devicedialbackevent: {
        getText: function (e) {
            var params = {
                user: getValue(e.details, 'user.name'),
                asset: getValue(e.details, 'asset.name'),
                number: getValue(e.details, 'dialback.number'),
            };
            if (e.type === 'success') {
                return { translationString: 'DEVICE_DIALBACK.SUCCESS', params: params };
            }
            else {
                return {
                    translationString: 'DEVICE_DIALBACK.FAILURE',
                    params: __assign(__assign({}, params), { error: getValue(e.details, 'error.message') }),
                };
            }
        },
    },
    devicetelemetrydownloadevent: {
        getText: function (e) {
            var params = {
                user: getValue(e.details, 'user.name'),
                asset: getValue(e.details, 'asset.name'),
                number: getValue(e.details, 'dialback.number'),
            };
            if (e.type === 'success') {
                return { translationString: 'DEVICE_TELEMETRY_DOWNLOAD.SUCCESS', params: params };
            }
            else {
                return {
                    translationString: 'DEVICE_TELEMETRY_DOWNLOAD.FAILURE',
                    params: __assign(__assign({}, params), { error: getValue(e.details, 'error.message') }),
                };
            }
        },
    },
    devicephototaskevent: {
        getText: function (e) {
            var params = {
                user: getValue(e.details, 'user.name'),
                camera: getValue(e.details, 'camera.name'),
                assettype: getValue(e.details, 'assetType.name'),
                asset: getValue(e.details, 'asset.name'),
            };
            if (e.type === 'success') {
                return { translationString: 'DEVICE_PHOTO_TASK.SUCCESS', params: params };
            }
            else {
                return {
                    translationString: 'DEVICE_PHOTO_TASK.FAILURE',
                    params: __assign(__assign({}, params), { error: getValue(e.details, 'error.message') }),
                };
            }
        },
    },
    devicetextmessagetaskevent: {
        getText: function (e) {
            var params = {
                user: getValue(e.details, 'user.name'),
                message: getValue(e.details, 'message.message'),
                assettype: getValue(e.details, 'assetType.name'),
                asset: getValue(e.details, 'asset.name'),
            };
            if (e.type === 'success') {
                return { translationString: 'DEVICE_TEXT_MESSAGE_TASK.SUCCESS', params: params };
            }
            else {
                return {
                    translationString: 'DEVICE_TEXT_MESSAGE_TASK.FAILURE',
                    params: __assign(__assign({}, params), { error: getValue(e.details, 'error.message') }),
                };
            }
        },
    },
    deviceuserquerytaskevent: {
        getText: function (e) {
            var params = {
                user: getValue(e.details, 'user.name'),
                query: getValue(e.details, 'query.name'),
                asssettype: getValue(e.details, 'assetType.name'),
                asset: getValue(e.details, 'asset.name'),
            };
            if (e.type === 'success') {
                return {
                    translationString: 'DEVICE_USER_QUERY_TASK.SUCCESS',
                    params: __assign(__assign({}, params), { message: getValue(e.details, 'data.message') }),
                };
            }
            else {
                return {
                    translationString: 'DEVICE_USER_QUERY_TASK.FAILURE',
                    params: __assign(__assign({}, params), { error: getValue(e.details, 'error.message') }),
                };
            }
        },
    },
    deviceaddressmessagetaskevent: {
        getText: function (e) {
            var params = {
                user: getValue(e.details, 'user.name'),
                message: getValue(e.details, 'message.message'),
                assettype: getValue(e.details, 'assetType.name'),
                asset: getValue(e.details, 'asset.name'),
            };
            if (e.type === 'success') {
                return { translationString: 'DEVICE_ADDRESS_MESSAGE.SUCCESS', params: params };
            }
            else {
                return {
                    translationString: 'DEVICE_ADDRESS_MESSAGE.FAILURE',
                    params: __assign(__assign({}, params), { error: getValue(e.details, 'error.message') }),
                };
            }
        },
    },
    temperatureinputevent: {
        getText: function (e) {
            var params = {
                input: getValue(e.details, 'input.name'),
                assettype: getValue(e.details, 'assetType.name'),
                asset: getValue(e.details, 'asset.name'),
                address: getValue(e.details, 'telemetry.location.address'),
            };
            switch (e.type) {
                case 'high':
                    return {
                        translationString: 'TEMPERATURE_INPUT.HIGH',
                        params: __assign(__assign({}, params), { value: getValue(e.details, 'values.value'), limit: getValue(e.details, 'values.limit') }),
                    };
                case 'low':
                    return {
                        translationString: 'TEMPERATURE_INPUT.LOW',
                        params: __assign(__assign({}, params), { value: getValue(e.details, 'values.value'), limit: getValue(e.details, 'values.limit') }),
                    };
                case 'out_range':
                    return { translationString: 'TEMPERATURE_INPUT.OUT_RANGE', params: params };
                case 'in_range':
                    return { translationString: 'TEMPERATURE_INPUT.IN_RANGE', params: params };
            }
        },
    },
    textmessageevent: {
        getText: function (e) {
            var params = {
                message: getValue(e.details, 'message'),
                assettype: getValue(e.details, 'assetType.name'),
                asset: getValue(e.details, 'asset.name'),
                address: getValue(e.details, 'telemetry.location.address'),
            };
            if (e.details.driver) {
                return {
                    translationString: 'TEXT_MESSAGE.DRIVER',
                    params: __assign(__assign({}, params), { driver: getValue(e.details, 'driver.name') }),
                };
            }
            else {
                return { translationString: 'TEXT_MESSAGE.NO_DRIVER', params: params };
            }
        },
        getClassText: function (e) {
            return { translationString: 'EVENTS.NAMES.TEXTMESSAGEEVENT_' + e.type.toUpperCase() };
        }
    },
    triggeredevent: {
        getText: function (e) {
            var params = {
                event: getValue(e.details, 'event.name'),
                assettype: getValue(e.details, 'assetType.name'),
                asset: getValue(e.details, 'asset.name'),
                address: getValue(e.details, 'telemetry.location.address'),
            };
            if (e.details.driver) {
                return {
                    translationString: 'TRIGGERED.DRIVER',
                    params: __assign(__assign({}, params), { driver: e.details.driver.name }),
                };
            }
            else {
                return { translationString: 'TRIGGERED.NO_DRIVER', params: params };
            }
        },
        getClassText: function (e) {
            return { translationString: 'EVENTS.NAMES.TRIGGEREDEVENT.' + e.type.toUpperCase() };
        }
    },
    zoneevent: {
        getText: function (e) {
            var params = { zone: getValue(e.details, 'zone.name') };
            if (e.details.driver) {
                params['driver'] = e.details.driver.name;
            }
            switch (e.type) {
                case 'enter':
                    return {
                        translationString: (e.details.driver) ? 'ZONE.DRIVER_ENTER' : 'ZONE.NO_DRIVER_ENTER',
                        params: __assign(__assign({}, params), { type: getValue(e.details, 'zone.type'), assettype: getValue(e.details, 'assetType.name'), asset: getValue(e.details, 'asset.name') }),
                    };
                case 'exit':
                    return {
                        translationString: (e.details.driver) ? 'ZONE.DRIVER_EXIT' : 'ZONE.NO_DRIVER_EXIT',
                        params: __assign(__assign({}, params), { type: getValue(e.details, 'zone.type'), assettype: getValue(e.details, 'assetType.name'), asset: getValue(e.details, 'asset.name'), address: getValue(e.details, 'telemetry.location.address') }),
                    };
                case 'range_enter':
                    return {
                        translationString: (e.details.driver) ? 'ZONE.DRIVER_RANGE_ENTER' : 'ZONE.NO_DRIVER_RANGE_ENTER',
                        params: __assign(__assign({}, params), { type: getValue(e.details, 'zone.type'), assettype: getValue(e.details, 'assetType.name'), asset: getValue(e.details, 'asset.name'), address: getValue(e.details, 'telemetry.location.address') }),
                    };
                case 'range_exit':
                    return {
                        translationString: (e.details.driver) ? 'ZONE.DRIVER_RANGE_EXIT' : 'ZONE.NO_DRIVER_RANGE_EXIT',
                        params: __assign(__assign({}, params), { type: getValue(e.details, 'zone.type'), zone: getValue(e.details, 'zone.name'), assettype: getValue(e.details, 'assetType.name'), asset: getValue(e.details, 'asset.name'), address: getValue(e.details, 'telemetry.location.address') }),
                    };
                default:
                    return { translationString: 'ZONE.DEFAULT', params: params };
            }
        },
        getClassText: function (e) {
            return { translationString: 'EVENTS.NAMES.ZONEEVENT_' + e.type.toUpperCase() };
        }
    },
    tripviolationevent: {
        getText: function (e, units) {
            var driver = e.details.driver ? e.details.driver.name : undefined;
            var type = e.type;
            var value = getValue(e.details, 'limit.value');
            var limit = "".concat(value, " minutes");
            if (type === 'distance') {
                limit = units.format(value, 'distance');
            }
            var translationString = driver ? 'TRIP_LIMIT.DRIVER' : 'TRIP_LIMIT.NO_DRIVER';
            var params = {
                limit: limit,
                driver: driver,
                type: type,
                assettype: getValue(e.details, 'assetType.name'),
                asset: getValue(e.details, 'asset.name'),
            };
            return { translationString: translationString, params: params };
        },
        getClassText: function (e) {
            return { translationString: 'EVENTS.NAMES.TRIPVIOLATIONEVENT.' + e.type.toUpperCase() };
        }
    }
};
function getAndTranslateEventText(textSection, event, i18n, units) {
    var result = '';
    var dictionaryClass = exports.EVENT_TRANSLATION_DICTIONARY[event.class];
    if (dictionaryClass) {
        var classItem = dictionaryClass.getText(event, units);
        if (!classItem.params.address) {
            classItem.params['address'] = i18n.instant('SHARED.UNKNOWN_LOCATION');
        }
        if (classItem.params.assettype) {
            var type = classItem.params.assettype.split(' ').join('_');
            classItem.params.assettype = i18n.instant("SHARED.ASSET_TYPES.".concat(type.toUpperCase()));
        }
        result = i18n.instant('SHARED.FEED_ENTRY.EVENT.' + classItem.translationString + '.' + textSection.toUpperCase(), classItem.params);
    }
    else {
        result = i18n.instant('SHARED.FEED_ENTRY.EVENT.UNKNOWN.' + textSection.toUpperCase(), { event: event.class });
    }
    if (result) {
        return result.replace('({{driver}}) ', '').replace('{{driver}} ', '');
    }
    return result;
}
exports.getAndTranslateEventText = getAndTranslateEventText;
function getAndTranslateEventClassText(event, i18n) {
    var dictionaryClass = exports.EVENT_TRANSLATION_DICTIONARY[event.class];
    if (dictionaryClass) {
        if (dictionaryClass.getClassText) {
            var classItem = dictionaryClass.getClassText(event);
            if (classItem.value)
                return classItem.value;
            return i18n.instant(classItem.translationString, classItem.params);
        }
        return i18n.instant('EVENTS.NAMES.' + event.class.toUpperCase());
    }
}
exports.getAndTranslateEventClassText = getAndTranslateEventClassText;
function getEventInfoText(event, i18n, units) {
    var dictionaryClass = exports.EVENT_TRANSLATION_DICTIONARY[event.class];
    if (dictionaryClass && dictionaryClass.getInfo) {
        var result = dictionaryClass.getInfo(event, i18n, units);
        return result || [];
    }
    return [];
}
exports.getEventInfoText = getEventInfoText;
